import QuickGoalCompletion from './QuickGoalCompletion'; export default QuickGoalCompletion;
